import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// feature fleet-map
import * as Actions from './actions';
//////////////////////////////////////////////////

const initialState = {
  fleets: {
    trucks: [],
    drivers: [],
    trailers: [],
    fleetsLoaded: {
      trucks: false,
      drivers: false,
      trailers: false,
    },
    geoFencingLocation: null,
  },
  configs: null,
  idleTimeFilter: [],
  flyToLocation: null,
  enterpriseFilter: [],
  flyToLocationValue: '',
  trailerUnitIdFilter: null,
  trailerLoadedFilter: false,
};

const getBranchConfigsByNamesSuccess = (state, configs) => P.$set(
  'configs', configs, state,
);

const setFleetsToStore = (state, { fleetType, data }) => (
  P.$all(
    P.$set(`fleets.${fleetType}`, data),
    P.$set(`fleets.fleetsLoaded.${fleetType}`, true),
    state,
  )
);

const setGeoFencingLocationToStore = (state, { results }) =>
  P.$set('geoFencingLocation', results, state);

const setFleetsLoadedToStore = (state, fleetsLoaded) =>
  P.$set('fleets.fleetsLoaded', fleetsLoaded, state);

const setEnterpriseFilter = (state, enterpriseFilter) =>
  P.$set('enterpriseFilter', enterpriseFilter, state);

const setIdleTimeFilter = (state, idleTimeFilter) =>
  P.$set('idleTimeFilter', idleTimeFilter, state);

const setTrailerLoadedFilter = (state, trailerLoadedFilter) =>
  P.$set('trailerLoadedFilter', trailerLoadedFilter, state);

const setTrailerUnitIdFilter = (state, trailerUnitIdFilter) =>
  P.$set('trailerUnitIdFilter', trailerUnitIdFilter, state);

const setGeoFencingLocationTypeFilter = (state, typeFilter) =>
  P.$set('geoFencingTypeFilter', typeFilter, state);

const cleanFleetMapStore = () => (
  initialState
);

const setFlyToLocation = (state, flyToLocation) => P.$set('flyToLocation', flyToLocation, state);
const setFlyToLocationValue = (state, flyToLocationValue) => P.$set('flyToLocationValue', flyToLocationValue, state);

export default createReducer({
  [Actions.setFleetsToStore]: setFleetsToStore,
  [Actions.setFlyToLocation]: setFlyToLocation,
  [Actions.setIdleTimeFilter]: setIdleTimeFilter,
  [Actions.cleanFleetMapStore]: cleanFleetMapStore,
  [Actions.setEnterpriseFilter]: setEnterpriseFilter,
  [Actions.setFlyToLocationValue]: setFlyToLocationValue,
  [Actions.setFleetsLoadedToStore]: setFleetsLoadedToStore,
  [Actions.setTrailerLoadedFilter]: setTrailerLoadedFilter,
  [Actions.setTrailerUnitIdFilter]: setTrailerUnitIdFilter,
  [Actions.setGeoFencingLocationToStore]: setGeoFencingLocationToStore,
  [Actions.getBranchConfigsByNamesSuccess]: getBranchConfigsByNamesSuccess,
  [Actions.setGeoFencingLocationTypeFilter]: setGeoFencingLocationTypeFilter,
}, initialState);
